<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Recurso Financeiro
        </h2>
        <v-row>
          <v-col>
            <v-text-field
              label="Tipo"
              name="tipo"
              type="text"
              v-model="recurso.tipo"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="recurso.ativos"
              id="ativos"
              color="primary"
              label="Ativo"
            />
          </v-col>
        </v-row>

        <fieldset>
          <legend>Marco Legal</legend>
          <v-row>
            <v-col>
              <v-text-field
                label="Tipo"
                name="marcoLegalTipo"
                type="text"
                :rules="rules"
                required
                v-model="recurso.marcoLegalTipo"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                label="Número"
                name="marcoLegalNumero"
                type="text"
                :rules="rules"
                required
                v-model="recurso.marcoLegalNumero"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Ano"
                name="marcoLegalAno"
                type="number"
                :rules="rules"
                required
                v-model="recurso.marcoLegalAno"
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col>
            <v-select
              v-model="recurso.fontes"
              :items="fontes"
              label="Fontes"
              :rules="rules"
              item-text="nome"
            />
          </v-col>
          <v-col v-if="recurso.fontes === 'Outros'">
            <v-text-field
              label="Outros"
              name="fontesOutras"
              type="text"
              required
              v-model="recurso.fontesOutras"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-text-field
          label="Link"
          name="link"
          type="text"
          v-model="recurso.link"
          required
          :rules="rules"
          background-color="white"
        />

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { recursosFinanceirosApi } from "../Api/recursosFinanceiros";
export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      recurso: {},
      payload: {
        municipioId: this.$route.params.id,
      },
      fontes: ["Municipal", "Estadual", "Federal", "Outros"],
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      recursosFinanceirosApi
        .find(this.tabId)
        .then(({ data }) => {
          this.recurso = data;
          if (!this.fontes.some((item) => item === this.recurso.fontes)) {
            this.recurso.fontesOutras = this.recurso.fontes;
            this.recurso.fontes = "Outros";
          }
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar recurso");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.recurso.municipioId = this.payload.municipioId;

      if (this.recurso.fontes === "Outros") {
        this.recurso.fontes = this.recurso.fontesOutras;
      }

      if (this.tabId > 0) {
        recursosFinanceirosApi
          .update(this.recurso)
          .then(() => {
            this.$notification.success("recurso editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Ator");
            console.log("Erro no submit ", err);
          });
      } else {
        recursosFinanceirosApi
          .create(this.recurso)
          .then(() => {
            this.$notification.success("recurso criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar recurso");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}
fieldset {
  padding: 10px;
  margin-bottom: 30px;
  border: 1px solid rgba(0, 0, 0, 0.87);
}
legend {
  padding: 10px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
